export default {
  index: [
    {
      path: '/teauser',
      component: resolve => require(['./tea_userIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/tea_user/_router.js